import _ from 'lodash';
import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	getSecondsFromTimeRange,
	returnAgeSeconds,
	readableStamp,
} from '../../../../utils/dateFunctions';
import {
	lookupUserById,
} from '../../../../actions/lookups';

const VehicleHistorySummarySingle = ({ department_history, current }) => {
	const dispatch = useDispatch();
	const { all_departments, dealer_settings, installation } = useSelector(state => ({
		all_departments: state.settings_departments.original_departments,
		dealer_settings: state.settings_site.dealer_settings,
		installation: state.settings_dealerships.installation,
	}));
	const department = useMemo(() => {
		const filtered = _.sortBy(_.filter(all_departments, o => o.id === department_history.department_id), 'id');
		return filtered[0] || {};
	}, [all_departments, department_history.department_id]);
	const dealerSettingValue = useMemo(() => {
		const getSetting = (name) => {
			let value = _.sortBy(
				_.filter(dealer_settings, o => o.key === name && o.dealership === installation.subdomain),
				'id'
			);
			if (value.length === 0) {
				value = _.sortBy(
					_.filter(dealer_settings, o => o.key === name && (o.dealership === '' || o.dealership === null || o.dealership === undefined)),
					'id'
				);
			}
			return value.length > 0 && value[0]?.value !== undefined ? value[0].value : '';
		};
		return getSetting('second_time_tab');
	}, [dealer_settings, installation.subdomain]);
	const { totaltime, units, totalhours } = useMemo(() => {
		let totaltime = 0;
		switch (dealerSettingValue) {
			case 'age-24_7':
				totaltime = department_history.recon_total_24_7 || 0;
				break;
			case 'age-24_6':
				totaltime = department_history.recon_total_24_6 || 0;
				break;
			case 'age-24_5':
				totaltime = department_history.recon_total_24_5 || 0;
				break;
			default:
				totaltime = department_history.recon_total_24_7 || 0;
				break;
		}
		const totalhours = totaltime / (24 * 60 * 60);
		let units = ' hours';
		if (totaltime > (24 * 60 * 60)) {
			totaltime /= (24 * 60 * 60);
			units = ' days';
		} else {
			totaltime /= (60 * 60);
		}
		return { totaltime, units, totalhours };
	}, [dealerSettingValue, department_history]);
	const user_name = useMemo(() => {
		if (!department_history.recon_entered_by) return 'N/A';
		const user_id = dispatch(lookupUserById(department_history.recon_entered_by));
		return user_id && user_id.user_name ? user_id.user_name : 'N/A';
	}, [dispatch, department_history.recon_entered_by]);
	const unit = useMemo(() => (
		<span className={department.goal > totalhours ? 'float-right badge bg-success' : 'float-right badge bg-danger'}>
			{totaltime.toFixed(1)}
			{' '}
			{units}
		</span>
	), [department.goal, totalhours, totaltime, units]);
	const isStartTimeBlank = !department_history.recon_starttime || department_history.recon_starttime === '';

	return (
		<li key={`timeline_single_${department_history.id}`}>
			<div className={department.goal > totalhours ? 'timeline-badge bg-success' : 'timeline-badge bg-danger'}>
				<i className="fas fa-check-circle" />
			</div>
			<div className="timeline-panel bg-light box">
				<div className="timeline-heading">
					<h4 className="timeline-title text-capitalize">
						<span className="bg-light">
							{department.name || 'Unknown Department'}
							{' '}
							{unit}
						</span>
					</h4>
					<p>
						<small>
							<i className="glyphicon glyphicon-time" />
							{current ? 'Current Step ' : ''}
							<span className="bg-light">
								Entered: {isStartTimeBlank ? 'N/A' : readableStamp(department_history.recon_starttime)} by {user_name}
							</span>
						</small>
					</p>
				</div>
				<div className="timeline-body" />
			</div>
		</li>
	);
};

export default VehicleHistorySummarySingle;